<script>
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  props: {
    label: String,
    critical: Number,
    high: Number,
    medium: Number,
    low: Number,
    info: Number
  },
  mounted () {
    this.renderChart({
        labels: ['Уязвимости'],
        datasets: [
          {
            label: 'Критический',
            backgroundColor: 'red',
            data: [this.critical]
          },
          {
            label: 'Высокий',
            backgroundColor: 'orange',
            data: [this.high]
          },
          {
            label: 'Средний',
            backgroundColor: 'gold',
            data: [this.medium]
          },
          {
            label: 'Низкий',
            backgroundColor: 'blue',
            data: [this.low]
          },
          {
            label: 'Инфо',
            backgroundColor: 'green',
            data: [this.info]
          }
        ]
      },
      {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              stepSize: 1
            }
          }]
        },
        title: {
          display: true,
          text: this.label
        }
      })
  }
}
</script>
